// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AddingEventCard__Wrapper_zjL7J","City":"AddingEventCard__City_15jKS","AddToCalendar":"AddingEventCard__AddToCalendar_22ZMS","Link":"AddingEventCard__Link_rGqVQ"};